import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartComponent } from '@portal/app/charts/chart.component';
import { ChartModule } from 'angular-highcharts';
import { FormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { SharedModule } from '@portal/app/shared/shared.module';
import { DataGridModule } from '@portal/app/datagrid/data-grid.module';
import { ChartGroupComponent } from './chart-group/chart-group.component';
import { GeoExperimentResultChartGroupTableComponent } from '@portal/app/charts/geo-experiment-result/geo-experiment-result-chart-group-table/geo-experiment-result-chart-group-table.component';
import { CommonServicesModule } from '@libs/common-services';
import { TooltipModule } from 'primeng/tooltip';
import { DesignSystemModule } from '@libs/design-system';

@NgModule({
  declarations: [
    ChartComponent,
    ChartGroupComponent,
    GeoExperimentResultChartGroupTableComponent
  ],
  exports: [
    ChartComponent,
    ChartGroupComponent,
    GeoExperimentResultChartGroupTableComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ChartModule,
    InputNumberModule,
    SharedModule,
    DataGridModule,
    CommonServicesModule,
    TooltipModule,
    DesignSystemModule
  ]
})
export class ChartsModule {}
